import React from 'react';
import Grid from '@mui/material/Grid2';
import { IEducationalVideoItem } from '../../../dataObjects/models/educationalVideos';
import { EducationalVideosVideoGridViewItem } from './EducationalVideosVideoGridViewItem';


export interface IEducationalVideosVideoGridViewProps {
  productVideos: Array<IEducationalVideoItem>;
}


export const EducationalVideosVideoGridView: React.FC<IEducationalVideosVideoGridViewProps> = (props: IEducationalVideosVideoGridViewProps) => {
  EducationalVideosVideoGridView.displayName = 'Product Videos Video Grid View';

  const { productVideos } = props;

  return (
    <>
      {/* <Grid container spacing={2} > */}
      <Grid container spacing={2} >
        {
          productVideos.map(productVideo =>
            <Grid key={productVideo.id} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
              <EducationalVideosVideoGridViewItem productVideo={productVideo} />
            </Grid>
          )
        }
      </Grid>
    </>
  );

}